export default {
  name: 'recap',
  component_path: 'modules/procedures/blocks/static/BlockRecap'
}